import React from 'react';

import { EmployeeGroupsBase } from '../../../employee-groups/components/employee-groups-base';

export const EmployeeAutomationSendTo = ({
  automation,
}: {
  automation: StartDateTriggeredCommunication;
}) => (
  <div className="u-display-flex u-justifyContent-flexStart typo-subtitle u-margin-bottom">
    <div
      className={`u-margin-right-sm u-whiteSpace-nowrap ${
        automation.EmployeeAutomationRecipients.length ? 'u-margin-top-md' : ''
      }`}
    >
      {automation.communicationType === 'alert' ? 'Notify For:' : 'Send To:'}
    </div>
    <div>
      {automation.EmployeeAutomationRecipients.length ? (
        <EmployeeGroupsBase
          employeeGroupIds={automation.EmployeeAutomationRecipients.map((r) => r.employeeGroupId)}
          orgId={automation.orgId}
        />
      ) : (
        'All Employees'
      )}
    </div>
  </div>
);
